import React from 'react';
import { Reveal } from './Reveal';
const INTRO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/4fff94d9-134b-4064-a801-f87e1e712490.jpg';
export function Introduction() {
  return <section aria-labelledby="introduccion" className="bg-warmwhite px-6 py-28 sm:px-10 sm:py-40" style={{
    paddingTop: "0px"
  }} data-id="element-112" data-mp="271f4tpm4z629">
      <div className="mx-auto max-w-6xl" data-id="element-113" data-mp="22ztm3nmx7xk5">
        <Reveal data-id="element-114" data-mp="1y19zdl0i6hqq">
          
        </Reveal>

        <div className="mt-12 grid gap-16 lg:grid-cols-12 lg:gap-20" data-id="element-115" data-mp="1y21vqy1xcji2">
          <div className="lg:col-span-7" data-id="element-116" data-mp="1ta1mug3vmg9c">
            <Reveal delay={0.05} data-id="element-117" data-mp="1t8yvk72n6bsw">
              <h2 id="introduccion" className="font-serif text-[1.85rem] font-light leading-[1.3] tracking-[-0.01em] text-ink-900 sm:text-[2.6rem]" data-id="element-118" data-mp="1obgokm86q6nj">
                La piel sana no empieza comprando más productos. Empieza
                entendiendo tu piel.
              </h2>
            </Reveal>

            <div className="mt-10 max-w-reading space-y-7 font-sans text-[1rem] font-light leading-[1.95] text-ink-500 sm:text-[1.05rem]" data-id="element-119" data-mp="1abpcir18b0c6">
              <Reveal delay={0.1} data-id="element-120" data-mp="2krnmee00e2ap">
                <p data-id="element-121" data-mp="2kqlyh8xw9lbk">
                  Casi todas las rutinas que no funcionan tienen algo en común:
                  fueron armadas a partir de recomendaciones, promesas y
                  entusiasmo, pero nunca a partir de una observación real de la
                  piel que las recibe.
                </p>
              </Reveal>
              <Reveal delay={0.14} data-id="element-122" data-mp="33jg6fix3od6a">
                <p data-id="element-123" data-mp="33khque00ac0o">
                  Cambiar de crema es rápido. Entender por qué la anterior no
                  funcionó lleva un poco más de tiempo, y es lo único que evita
                  repetir el mismo camino con otro envase.
                </p>
              </Reveal>
              <Reveal delay={0.18} data-id="element-124" data-mp="2zgtj9vbdjgff">
                <p className="border-l border-sage-200 pl-6 font-serif text-[1.35rem] italic leading-[1.6] text-ink-700 sm:text-[1.5rem]" data-id="element-125" data-mp="2zfrxavstl9ix">
                  Antes de agregar, conviene entender. Antes de comprar,
                  conviene observar.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-126" data-mp="3ptg96omujj0k">
            <Reveal delay={0.12} as="figure" data-id="element-127" data-mp="3ktk0ic37f3eo">
              <div className="grain group relative overflow-hidden rounded-[1.5rem] bg-cream sm:rounded-[2rem]" data-id="element-128" data-mp="3kuv4od0kad6b">
                
              </div>
              <figcaption className="mt-4 font-sans text-[0.7rem] font-light uppercase tracking-[0.18em] text-ink-400" data-id="element-129" data-mp="3bz5oqjhvub0b">
                Frescura · Agua · Botánica
              </figcaption>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}